<template>
  <app-card v-bind="$attrs" class="v-card--material mt-4">
    <v-card-title class="align-start">
      <v-sheet
        :color="color"
        :width="fullHeader ? '100%' : undefined"
        class="overflow-hidden mt-n9 transition-swing v-card--material__sheet"
        elevation="6"
        max-width="100%"
        rounded
      >
        <v-theme-provider v-if="hasHeading" dark>
          <div v-if="icon" :class="iconSmall ? 'pa-6' : 'pa-7'">
            <v-icon :large="!iconSmall" v-text="icon" />
          </div>

          <slot name="heading" />

          <div v-if="heading" class="text-h4 white--text pa-7 v-card--material__title">
            {{ heading }}
          </div>
        </v-theme-provider>
      </v-sheet>

      <div v-if="hasTitle" :class="fullHeader ? 'pt-2 pb-1' : 'pl-3'" class="text-h4 v-card--material__title" style="white-space: normal">
        <slot name="title" />

        <template v-if="title">
          <div style="line-height: 1.2rem" v-html="title"></div>
        </template>

        <div class="text-subtitle-1 mb-n4">
          <slot name="subtitle" />

          <template v-if="subtitle">
            {{ subtitle }}
          </template>
        </div>
      </div>
    </v-card-title>

    <slot />

    <template v-if="$slots.actions">
      <v-divider class="mt-2 mx-4" />
      <v-card-actions class="px-4 text-caption grey--text">
        <slot name="actions" />
      </v-card-actions>
    </template>
  </app-card>
</template>

<script>
export default {
  name: "MaterialCard2",

  props: {
    color: String,
    fullHeader: Boolean,
    heading: String,
    icon: String,
    iconSmall: Boolean,
    subtitle: String,
    title: String,
    valueHeader: Boolean,
  },

  computed: {
    hasHeading() {
      return !!(this.icon || this.heading || this.$slots.heading || this.valueHeader);
    },
    hasTitle() {
      return !!(this.title || this.subtitle || this.$slots.title || this.$slots.subtitle);
    },
  },
};
</script>

<style lang="sass">
.v-card.v-card--material
  > .v-card__title
    > .v-card--material__title
      flex: 1 1 auto
      word-break: break-word
</style>
